import React from 'react';
import axios from 'axios';
import { Loading, ToastNotification, Modal } from 'carbon-components-react';
import { t } from '../../RI18n';
import './style.css';

class ServerUpgrade extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      serverUpgrade: [],
      isOpen: false,
    };
  }

  componentDidMount() {
    axios
      .get('/sam/todo_list/server_upgradable.json')
      .then((result) => {
        this.setState({
          isLoaded: true,
          serverUpgrade: result.data,
        });
      })
      .catch(() => {
        this.setState({
          isLoaded: true,
          error: true,
        });
      });
  }

  toggleModal = () => {
    this.setState((prevState) => ({
      isOpen: prevState.isOpen !== true,
    }));
  };

  render() {
    const { error, isLoaded, serverUpgrade } = this.state;

    if (serverUpgrade.to_display === false) {
      return null;
    }

    if (error) {
      console.log(t('todolist.server_upgrade.error'));
      return null;
    } if (!isLoaded) {
      return (
        <span>
          <br />
          <Loading small withOverlay={false} />
        </span>
      );
    }
    if (serverUpgrade.is_upgradeable === true) {
      if (this.props.notify) {
        this.props.updateToDos();
      }

      const newVersion = serverUpgrade.fixlet_version;
      const currentVersion = serverUpgrade.current_version;
      const notificationKind = serverUpgrade.is_warning === true ? 'warning' : 'error';
      const renderedReportStatusText = t(`widget.status.${notificationKind}`);
      const caption = serverUpgrade.is_admin === true
        ? t('todolist.server_upgrade.caption_admin')
        : '';
      const titleText = serverUpgrade.is_admin === true
        ? t('todolist.server_upgrade.title_admin')
        : t('todolist.server_upgrade.title_not_admin');

      const titleTextWithTooltip = <span className="notification_text" title={renderedReportStatusText}>{titleText}</span>;

      const details = serverUpgrade.is_lmt === true ? (
        <span
          dangerouslySetInnerHTML={{
            __html: t('todolist.server_upgrade.details_lmt'),
          }}
        />
      ) : (
        <span
          dangerouslySetInnerHTML={{
            __html: t('todolist.server_upgrade.details_bfi'),
          }}
        />
      );
      const upgradeBoxTitle = t(
        'todolist.server_upgrade.confirm.title',
      );
      const upgradeBoxButtonText = t(
        'todolist.server_upgrade.confirm.upgrade_bt',
      );
      const upgradeBoxCancelText = t(
        'todolist.server_upgrade.confirm.cancel_bt',
      );
      const upgradeBoxDescription = (
        <span>
          <span>
            {t('todolist.server_upgrade.confirm.description', serverUpgrade.is_lmt === true ? ({
              product_name: t('domains.sam.name_lmt'),
            }) : ({
              product_name: t('domains.sam.name'),
            }))}
          </span>
          <br />
          <span>
            {t('todolist.server_upgrade.confirm.details', serverUpgrade.is_lmt === true ? ({
              product_name: t('domains.sam.name_lmt'),
            }) : ({
              product_name: t('domains.sam.name'),
            }))}
          </span>
        </span>
      );

      const subtitleText = (
        <span className="notification_text">
          <span>
            {t('todolist.server_upgrade.new_version')}
            {' '}
            {newVersion}
          </span>
          <br />
          <span>
            {t('todolist.server_upgrade.current_version')}
            {' '}
            {currentVersion}
          </span>
        </span>
      );

      const captionText = serverUpgrade.is_admin === true ? (
        <span className="notification_text">
          <span>{caption}</span>
          <br />
          {details}
        </span>
      ) : (
        <span className="notification_text">
          <span>{caption}</span>
          <br />
          {details}
        </span>
      );

      return (
        <div>
          <ToastNotification
            className="notification_style"
            title={titleTextWithTooltip}
            subtitle={subtitleText}
            caption={captionText}
            kind={notificationKind}
            hideCloseButton
            aria-label={t('todolist.aria_label', { name: t('todolist.server_upgrade.name'), status: renderedReportStatusText })}
            role="region"
          />
          <Modal
            onClose={this.toggleModal}
            onRequestClose={this.toggleModal}
            open={this.state.isOpen}
            modalHeading={upgradeBoxTitle}
            primaryButtonText={upgradeBoxButtonText}
            secondaryButtonText={upgradeBoxCancelText}
            primaryButtonDisabled
          >
            <p className="bx--modal-content__text">{upgradeBoxDescription}</p>
          </Modal>
        </div>
      );
    }
    return null;
  }
}

export default ServerUpgrade;
